import React from 'react';

export default function SvgBack(): JSX.Element {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="a">
        <path d="m0 0h24v24h-24z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path d="m20 11h-12.17l5.59-5.59-1.42-1.41-8 8 8 8 1.41-1.41-5.58-5.59h12.17z" fill="#2f0d30" />
      </g>
    </svg>
  );
}
